import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';
import { catchError, filter, switchMap, take, throwError } from 'rxjs';
import { environment } from '../../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {

    const authService = inject(AuthService);

    // Clone request to set withCredentials: true for all API requests
    let authReq = req;
    if (req.url.startsWith(environment.apiUrl)) {
        authReq = req.clone({
            withCredentials: true
        });
    }

    return next(authReq).pipe(
        catchError((error) => {
            if (error instanceof HttpErrorResponse && error.status === 401) {
                // If it is a login or refresh request, don't try to refresh again
                if (req.url.includes('/users/login')) {
                    return throwError(() => error);
                }

                // If already refreshing, queue the request
                if (authService.isRefreshingToken) {
                    return authService.refreshTokenSubject.pipe(
                        filter(isRefreshed => isRefreshed),
                        take(1),
                        switchMap(() => next(authReq))
                    );
                }

                // Start refreshing token
                authService.isRefreshingToken = true;
                authService.refreshTokenSubject.next(false);

                return authService.refreshToken().pipe(
                    switchMap(() => {
                        authService.isRefreshingToken = false;
                        authService.refreshTokenSubject.next(true);
                        return next(authReq);
                    }),
                    catchError((refreshError) => {
                        authService.isRefreshingToken = false;
                        authService.refreshTokenSubject.next(false);
                        authService.logout();
                        return throwError(() => refreshError);
                    })
                );
            }
            return throwError(() => error);
        })
    );
};
